<template>
<div id="vendorAddModal" class="modal fade add-customer-popup">
        <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" style="max-width:1140px;">
            <div class="modal-content">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="customerModalLabel">Add Vendor</h5>
                    <!-- <h4 class="modal-title">Are you sure?</h4> -->
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i  class="ri-close-line"></i></button>
                </div>
                <div class="modal-body">

                <div class="add-customer-section">

                    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
                        <div class="new-rfq">
                            <div class="row">
                            <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                            <ul>
                                                <li>{{ errorMessage }}</li>
                                            </ul>
                                        </div>
                                <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                                    <strong class="success_msg">{{successMessage}}</strong>
                                </div>
                                <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                    <ul>
                                        <li v-for="(v, k) in commonErrors" :key="k">
                                        <p v-for="error in v" :key="error" class="text-sm">
                                        {{ error }}
                                        </p>
                                        </li>
                                    </ul>
                                </div>
                               
                                <div class="col-lg-12 col-md-12">
                                    <div class="border card-body mb-3 pb-0">

                                        <div class="container my-4">

  <div class="section-box">
    <h2 class="mb-3 inner-title">Company Information</h2>
    <div class="row g-4">

      <!-- Left column -->
      <div class="col-md-3">
        <div class="mb-3">
          <label class="form-label">Company Name</label>
          <validation-provider rules="required" v-slot="{ errors }">
            
            <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.company_name">
            <span class="error">{{ errors[0] }}</span>
        </validation-provider>
        </div>

        <div class="mb-3">
          <label class="form-label">Country</label>
          <validation-provider rules="required" v-slot="{ errors }">
           
            <select class="form-control" id="country_id" name="country_id" v-model="form.country_id">
                <option value="null">Select Country</option>
                <option v-for="country in countries" :value="country.id">{{country.name}}</option>
            </select>
            <span class="error">{{ errors[0] }}</span>
        </validation-provider>
        </div>

        <div class="mb-3">
          <label class="form-label">Website</label>
          <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.website" />
        </div>

        <!-- <div class="mb-3">
          <label class="form-label">Fax</label>
          <input type="text" class="form-control" placeholder="" name="fax" id="fax" v-model="form.fax" />
        </div> -->

      </div>

      


      <!-- Middle column -->
      <div class="col-md-4">
      <div class="form-group flex-fill">
       

        <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <label class="form-label">Company Address</label>
            <textarea class="form-control address-box" style="height:201px"  v-model="form.address" rows="12"></textarea>
            <!-- <span class="error">{{ errors[0] }}</span>
        </validation-provider> -->

       
        
      </div>
        

        
      </div>

      <!-- Right column -->
      <div class="col-md-5">
        <label class="form-label">Sample Address</label>

        

        
        <textarea class="form-control address-box" v-model="form.sample_address" style="height:201px" rows="12"></textarea>
      </div>

    </div>
  </div>

</div>

                                        <!-- <div class="">
                                            <h2 class="mb-3 inner-title">Company Information</h2>
                                            <div class="row">

                                            
                                                <div class="col-lg-4 col-md-4">
                                                    <div class="form-group flex-fill">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                        <label>Company Name</label>
                                                        <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.company_name">
                                                        <span class="error">{{ errors[0] }}</span>
                                                    </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-4">
                                                    <div class="form-group flex-fill">
                                                        
                                                        <GooglePlaceAutoCompleteSingle v-if="loadMap"
                                                        :title="'Company Address'"
                                                        :placeholder="'Company Address'"
                                                        :errors="null"
                                                        v-model="form.address"
                                                        @selectedEvent="selectCompanyAddress"></GooglePlaceAutoCompleteSingle>
                                                        
                                                    </div>
                                                </div>

                                                 <div class="col-lg-4 col-md-4">
                                                    <div class="form-group flex-fill">
                                                        
                                                        <GooglePlaceAutoCompleteSingle v-if="loadMap"
                                                        :title="'Company Address'"
                                                        :placeholder="'Company Address'"
                                                        :errors="null"
                                                        v-model="form.address"
                                                        @selectedEvent="selectCompanyAddress"></GooglePlaceAutoCompleteSingle>
                                                        
                                                    </div>
                                                </div>

                                                <div class="col-lg-1 col-md-1">
                                                    <div class="form-group flex-fill">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                        <label>Country</label>
                                                        <select class="form-control" id="country_id" name="country_id" v-model="form.country_id">
                                                            <option value="null">Select Country</option>
                                                            <option v-for="country in countries" :value="country.id">{{country.name}}</option>
                                                        </select>
                                                        <span class="error">{{ errors[0] }}</span>
                                                    </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="col-lg-1 col-md-1">
                                                    <div class="form-group flex-fill">
                                                        <label>Website</label>
                                                        <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.website" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-1 col-md-1">
                                                    <div class="form-group flex-fill">
                                                        <label>Fax</label>
                                                        <input type="text" class="form-control" placeholder="" name="fax" id="fax" v-model="form.fax" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="border card-body mb-3 pb-0">
                                        <div class="">
                                            <div class="add-container">
                                                <h2 class="inner-title">Contact</h2>
                                                    <div class="product-create">
                                                    <div id="email_alert" class="alert alert-danger" style="display: none;">
                                                        <strong>Please fill out * fields</strong>
                                                    </div>
                                                <div class="btn btn-info plus-icon dff-pos" width="25px;" @click="addNewContact()" alt="plus-icon" ><i class="ri-add-circle-line align-middle"></i> Add New</div>
                                                <div class="add_new_contact">
                                                    <template v-for="(contact, index) in form.contacts">
                                                        <div class="contact-dtlbox">
                                                            <div class="row count_contact contact_1">
                                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                                    <div class="form-group">
                                                                        <label for="contact_name" class="control-label">Full Name </label>
                                                                        <input type="text" class="form-control" id="contact_name" name="contact_name" v-model="contact.contact_name">
                                                                    </div>
                                                                    <span class="error">{{ errors[0] }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                    <div class="form-group">
                                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                                        <label for="contact_email" class="control-label">Email </label>
                                                                        <input type="email" class="form-control" id="contact_email" name="contact_email" v-model="contact.contact_email">
                                                                        <span class="error">{{ errors[0] }}</span>
                                                                    </validation-provider>
                                                                    </div>
                                                                </div>
                                                                <template v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" v-if="contactIndex == 0">
                                                                        <div class="form-group cmbne-sel-inpt">
                                                                            <label>Contact</label>
                                                                            <div class="add-contact">
                                                                                <select class="form-control select-control" name="contact_phn_type" v-model="contact_number.contact_phn_type">
                                                                                    <option value="Mobile">Mobile</option>
                                                                                    <option value="Office">Office</option>
                                                                                </select>
                                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                                <input type="text" class="form-control contact_no"  name="contact_phone_no" v-model="contact_number.contact_phone_no"/>
                                                                                <span class="error">{{ errors[0] }}</span>
                                                                                </validation-provider>
                                                                                <div class="action-btn">
                                                                                    <div v-if="contactIndex == 0" class="plus-icon" @click="addNewNumber(index)" alt="plus-icon" ><i class="ri-add-circle-line"></i></div>

                                                                                </div>
                                                                            </div>
                                                                            <div class="action-btn-row">
                                                                                    <a v-if="contactIndex > 0" class="minus-icon"  @click="removeNumber(index, contactIndex)"  href="javascript:void(0);" ><i class="ri-delete-bin-6-line"></i></a>
                                                                                    <a v-if="index > 0" class="btn btn-danger remove mt-1" @click="removeContact(index)"  href="javascript:void(0);" >Remove</a>
                                                                                </div>
                                                                        </div>

                                                                    </div>

                                                                </template>


                                                            </div>

                                                            <div class="row contact_row_1 number_row">
                                                                <template v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" v-if="contactIndex> 0">
                                                                        <div class="form-group cmbne-sel-inpt">
                                                                            <div class="add-contact">
                                                                                <select class="form-control select-control" name="contact_phn_type" v-model="contact_number.contact_phn_type">
                                                                                    <option value="Mobile">Mobile</option>
                                                                                    <option value="Office">Office</option>
                                                                                </select>
                                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                                <input type="text" class="form-control contact_no"  name="contact_phone_no" v-model="contact_number.contact_phone_no"/>
                                                                                <span class="error">{{ errors[0] }}</span>
                                                                                </validation-provider>
                                                                                <div class="action-btn">
                                                                                    <div v-if="contactIndex == 0" class="plus-icon" @click="addNewNumber(index)" alt="plus-icon" ><i class="ri-add-circle-line"></i></i></div>
                                                                                    <a v-if="contactIndex > 0" class="minus-icon btn btn-danger" @click="removeNumber(index, contactIndex)"  href="javascript:void(0);" ><i class="ri-delete-bin-6-line"></i></a>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                </template>
                                                            </div>
                                                        <!-- <div class="row contact_row_1 number_row">
                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                <div class="form-group">
                                                                    <label for="status" class="mdl-textfield__label">Status </label>
                                                                    <select class="form-control mdl-textfield__input" id="status" name="status" v-model="contact.status">
                                                                        <option value="1">Active</option>
                                                                        <option value="2">InActive</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div> -->

                                                        </div>
                                                    </template>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="border card-body mb-3 pb-0">

                                            <div class="">
                                                <h2  class="inner-title">Terms of Vendor </h2>

                                                    <div class="form-group">
                                                    <textarea rows="4" class="form-control" v-model="form.vendor_terms" placeholder=""></textarea>
                                                    </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="border card-body mb-3 pb-0">
                                    <div class="row ">
                                        <div class="col-lg-3 col-md-3">

                                            <div class="form-group">
                                            <label for="status" class="mdl-textfield__label">Found them</label>
                                            <!-- <input type="text" class="form-control" v-model="form.found_them" > -->
                                            <v-select label="found_them" taggable  placeholder="Select Found them"    v-model="form.found_them" :filterable="true" :options="optionsFound" :reduce="(option) => option.found_them">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.found_them }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.found_them }}
                                                    </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>

                                        <div class="col-lg-3 col-md-3">
                                                <!-- <div class="card-header">
                                                    <div class="card-header-left pull-left">
                                                        <h3>About the Customer </h3>
                                                    </div>
                                                </div> -->
                                                <div class="form-group">
                                                <label for="status" class="mdl-textfield__label">Doing Exports?</label>
                                            <input type="text" class="form-control mdl-textfield__input" id="doing_exports" name="doing_exports" v-model="form.doing_exports">

                                                </div>
                                        </div>

                                        <div class="col-lg-3 col-md-3">
                                                <!-- <div class="card-header">
                                                    <div class="card-header-left pull-left">
                                                        <h3>About the Customer </h3>
                                                    </div>
                                                </div> -->
                                                <div class="form-group">
                                                <label for="status" class="mdl-textfield__label">Vendor Business</label>
                                            <v-select label="bag_name" taggable  placeholder="Select Vendor Business" multiple v-model="form.vendor_bag" :filterable="true" :options="options" :reduce="(option) => option.id">
                                                    <template slot="no-options">
                                                    Search
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.bag_name }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.bag_name }}
                                                    </div>
                                                    </template>
                                                </v-select>
                                                </div>
                                        </div>

                                        <div class="col-lg-3 col-md-3">
                                                
                                                <div class="form-group">
                                                <validation-provider rules="required" v-slot="{ errors }">
                                                    <label for="status" class="mdl-textfield__label">Status *</label>
                                                    <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.status">
                                                        <option value="1">Active</option>
                                                        <option value="2">InActive</option>
                                                        <option value="3">New Vendor</option>
                                                    </select>
                                                    <span class="error">{{ errors[0] }}</span>
                                                </validation-provider>

                                                </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="border card-body mb-3 pb-0">
                                    <!-- <h2  class="inner-title">Other </h2> -->
                                    <div class="row ">
                                        <div class="col-lg-6 col-md-6">
                                                <div class="form-group">
                                                <label>About the Vendor</label>
                                                <textarea rows="4" class="form-control address-box" style="height:120px" v-model="form.aboutv" placeholder=""></textarea>
                                                
                                                
                                                </div>

                                        </div>

                                        <div class="col-lg-6 col-md-6">
                                                
                                                <div class="form-group">
                                                <div  v-cloak @drop.prevent="addFile" @dragover.prevent class="files task-files">
                                                <input type="file" name="csv_file" v-on:change="handleFileUpload" ref="csv_file" style="border: none;">
                                                    <h2>Files to Upload (Drag them over)</h2>

                                                    <ul>
                                                        <li v-for="file in form.files">
                                                        {{ file.name }}  <button @click="removeFile(file)" title="Remove">X</button>
                                                        </li>
                                                    </ul>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="border card-body mb-3 pb-0">

                                            <div class="form-group">
                                                <div  v-cloak @drop.prevent="addFile" @dragover.prevent class="files task-files">
                                                <input type="file" name="csv_file" v-on:change="handleFileUpload" ref="csv_file" style="border: none;">
                                                    <h2>Files to Upload (Drag them over)</h2>

                                                    <ul>
                                                        <li v-for="file in form.files">
                                                        {{ file.name }}  <button @click="removeFile(file)" title="Remove">X</button>
                                                        </li>
                                                    </ul>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->




                                </div>
                            </div>


                                <div class="btnrow text-right">
                                    <button type="button" class="btn btn-danger me-1" data-dismiss="modal" aria-hidden="true">Discard</button>
                                    <!-- <router-link :to="{name: 'viewVendors'}" class="btn skip-btn">Discard</router-link> -->
                                    <button type="submit" class="btn btn-primary" id="save_customer_btn">Save</button>
                                    <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
                                </div>
                        </div>
                    </form>
                    </ValidationObserver>

                    </div>

                </div>


            </div>
        </div>
    </div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
//import GooglePlaceAutoCompleteSingle from "./GooglePlaceAutoCompleteSingle";
import axios from "axios";
import VueCkeditor from 'vue-ckeditor2';
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  });
}
export default {
    name: "VendorAddModal",
    components: {
        ValidationProvider,ValidationObserver,VueCkeditor
    },
    created() {
        this.getCountries();
        this.getVendorBag();
        this.getFoundThem();
    },
    mounted() {
        this.loadMap = true;
    },
    data(){
        return {
            editorConfigMin: {
                // height: 400,
                // toolbar: [],
                // ui: { top: 10, right: 10, bottom: 10, left: 10}
                toolbar: [
                [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript' ]
                ],
                height: 300
            },
            config: { // Optional configuration object
                toolbar: [
                [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript' ]
                ],
                height: 300
            },

            loadMap : false,
            selected:[],
            options:[],
            optionsFound:[],
            taskPriority:[],
            inlineDatePicker:true,
            autoApply:false,
            singleDatePicker:true,
            showDropdowns:true,
            countries: [],
            form: {
                sample_address:null,
                vendor_bag:[],
                files:[],
                selected:[],
                id: null,
                company_name: null,
                address: null,
                country_id: null,
                website: '',
                fax: '',
                aboutv:'',
                contacts: [
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                about_us: '',
                status: 1,
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading'
        ]),
        selectCompanyAddress(place){
            let country = place.address_components.find((x) => x.types.includes('country'));

            if(country) {
                let selectedCountry = this.countries.find((x) => x.code === country.short_name);
                if(selectedCountry) {
                    this.form.country_id = selectedCountry.id;
                }
            }

            if(place.name != '') {
                this.form.address = place.formatted_address;
            }
            else{
                this.form.address = place.formatted_address;
            }
        },
        addFile(e) {
            let droppedFiles = e.dataTransfer.files;
            if(!droppedFiles) return;
            // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
            ([...droppedFiles]).forEach(f => {
                this.form.files.push(f);
            });
            console.log("files ",this.form.files);
        },
        removeFile(file){
            this.form.files = this.form.files.filter(f => {
                return f != file;
            });
        },
        handleFileUpload(){
            this.form.files.push(this.$refs.csv_file.files[0]);
            //this.csv_file = this.$refs.csv_file.files[0];
        },
        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('searchVendorsBag',{searchTerm: search,selected_vendor:this.form.vendor_bag} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    console.log("Length",data);

                    let allData =  data.data.data

                    //console.log("Length",allData,allData.length);
                   // vm.options = data.data.data;

                    for (var i = 0; i < data.data.data.length; i++)
                    {
                          vm.options.push({id:allData[i].id,bag_name:allData[i].bag_name});

                    }

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        save() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let formData = new FormData();
            if(this.form.files){
                this.form.files.forEach((f,x) => {
                formData.append('file[]', f);
            });
            }

            formData.append('company_name', this.form.company_name);
            //formData.append("_method", "PUT")
            formData.append('address', this.form.address);
            formData.append('sample_address', this.form.sample_address);
            formData.append('country_id', this.form.country_id);
            formData.append('website', this.form.website);
            formData.append('fax', this.form.fax);
            // this.form.contacts.forEach((f,x) => {
            //     //this.form.locations.forEach((location, i) => form.append(`locations[${i}]`, location));
            //     formData.append(`contacts[${x}]`, f);
            // });
            //JSON.stringify(game)
            formData.append('contacts', JSON.stringify(this.form.contacts));
            formData.append('vendor_terms', this.form.vendor_terms);
            formData.append('found_them', this.form.found_them);
            formData.append('doing_exports', this.form.doing_exports);
             this.form.vendor_bag.forEach((f,x) => {
                formData.append('vendor_bag[]', f);
            });

           // formData.append('vendor_bag', this.form.vendor_bag);
            formData.append('aboutv', this.form.aboutv);
            formData.append('status', this.form.status);

            return axios.post(window.route('vendors.store'), formData,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                },
                headers: {
                        'Content-Type': 'multipart/form-data'
                },
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.vendorData = data.data;
                        this.$emit('vendorDataSaved', data.vendor);
                        console.log(data);
                       self.setSuccessMessage("Vendor added successfully.");
                        this.reset();
                        setTimeout(() => {

                            $('#vendorAddModal').modal('hide');
                            self.setSuccessMessage(null);
                        }, 3500);
                        //self.$router.push({ name: 'viewVendors' });

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        async reset() {
            this.form =  {
                            id: null,
                            company_name: null,
                            address: null,
                            country_id: null,
                            website: null,
                            fax: null,
                            contacts: [
                                {
                                    contact_id: null,
                                    contact_name: null,
                                    contact_email: null,
                                    contact_numbers: [
                                        {
                                            contact_phn_type: 'Mobile',
                                            contact_phone_no: null,
                                        }
                                    ]
                                }
                            ],
                            about_us: null,
                            status: 1,
                        };
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
        },
        addNewContact() {
            this.form.contacts.push({
                contact_id: null,
                contact_name: null,
                contact_email: null,
                contact_numbers: [
                    {
                        contact_phn_type: 'Mobile',
                        contact_phone_no: null,
                    }
                ]
            });

            console.log(this.form.contacts.length);

        },
        removeContact(index){
            this.form.contacts.splice(index, 1);
        },
        addNewNumber(index) {
            this.form.contacts[index].contact_numbers.push({
                contact_phn_type: 'Mobile',
                contact_phone_no: null,
            });
        },
        removeNumber(index, contactIndex) {
            this.form.contacts[index].contact_numbers.splice(contactIndex, 1);
        },
        getCountries() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('countries.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.countries = data.data.countries;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getVendorBag() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getVendorBag'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.options = data.data.data;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        
        getFoundThem() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getFoundThem'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                       // self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                       // self.setErrorMessage(data.errorMessage);
                    } else {
                        this.optionsFound = data.data.data;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
 .address-box {
    height: 201px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    resize: none;
  }
</style>
